import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import '../css/main_style.css';
import apiaddressredirect from "../apiaddressredirect.json";


class ScheduleHours extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'',starting:'', ending:'',holidayname:'', holidaydate:'', holidays:'', Items:[]};				
	}

	componentDidMount() {		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})			
			axios.post(process.env.REACT_APP_API_ENV+'api/hours.php')			
			.then(result => {	
				this.setState({starting:result.data[0]});
				this.setState({ending:result.data[1]});
			})		
		axios.post(process.env.REACT_APP_API_ENV+'api/holidays.php')			
			.then(result => {				
				this.setState({holidays:result.data[2]})
				this.setState({holidayname:result.data[0]})
				this.setState({holidaydate:result.data[1]})
			})
		axios.post(process.env.REACT_APP_API_ENV+'api/updatenews.php')			
			.then(result => {
				this.setState({Items:result.data})			
			})
	
	
	}
	render() {	
		return(
			<div id="qualificationsection">				
				{(()=>{if(this.state.Items.filter(sub=>sub[0] == "BRAND").map(sub=>sub[2]) >=0 && this.state.Items.filter(sub=>sub[0] == "BRAND").map(sub=>sub[3]) <=0 && this.state.Items.filter(sub=>sub[0] == "BRAND").map(sub=>sub[1]) !="" ) {return (
					<h3 className="headings" style={{textAlign:"left",color:"red", marginLeft:"10px"}}>
					<small>{this.state.Items.filter(sub=>sub[0] == "BRAND").map(sub=>sub[1])}</small></h3>
				)}})()}
				{(()=>{if(this.state.Items.filter(sub=>sub[0] == "NOTICE").map(sub=>sub[2]) >=0 && this.state.Items.filter(sub=>sub[0] == "NOTICE").map(sub=>sub[3]) <=0) {return (
					<h3 className="headings" style={{textAlign:"left",color:"red", marginLeft:"10px"}}>
					<small>{this.state.Items.filter(sub=>sub[0] == "NOTICE").map(sub=>sub[1])}</small></h3>
				)}})()}				
				{(()=>{if(this.state.Items.filter(sub=>sub[0] == "NOTICE").map(sub=>sub[0]) =="") {return (
					<h3 className="headings" style={{textAlign:"left",color:"red", marginLeft:"10px"}}>
					Due to hosting company tech issue, please click <Link style={{color:"blue"}} to = {{pathname: apiaddressredirect.IPAddress+"Apply"}} target="_blank">here</Link> for your loan application</h3>
				)}})()}
				{(()=>{if(this.state.holidays > 0) {return (
					<p style={{textAlign:"center",color:"blue"}}>
						<span>Today our office is closed on holiday--{this.state.holidayname}</span> 
					</p>
				)}})()}				
			</div>
		)
	}
}

export default ScheduleHours	